import { getGlobalThis, isServer } from '../utils/index.js';
const breakpoints = {
    huge: '1400px',
    extraLarge: '1200px',
    large: '960px',
    medium: '600px',
};
export function onDeviceSizeChange(callback) {
    if (isServer())
        return () => {
            // nop
        };
    function notifyDeviceSize() {
        callback(getDeviceSize());
    }
    // Install listeners on the media query. When matched, the
    // respective action will be triggered to update the state.
    mediaQueryMedium().addEventListener('change', notifyDeviceSize);
    mediaQueryLarge().addEventListener('change', notifyDeviceSize);
    mediaQueryExtraLarge().addEventListener('change', notifyDeviceSize);
    mediaQueryHuge().addEventListener('change', notifyDeviceSize);
    return () => {
        mediaQueryMedium().removeEventListener('change', notifyDeviceSize);
        mediaQueryLarge().removeEventListener('change', notifyDeviceSize);
        mediaQueryExtraLarge().removeEventListener('change', notifyDeviceSize);
        mediaQueryHuge().removeEventListener('change', notifyDeviceSize);
    };
}
const win = getGlobalThis();
const mediaQueryHuge = () => win.matchMedia(`(min-width: ${breakpoints.huge})`);
const mediaQueryExtraLarge = () => win.matchMedia(`(min-width: ${breakpoints.extraLarge})`);
const mediaQueryLarge = () => win.matchMedia(`(min-width: ${breakpoints.large})`);
const mediaQueryMedium = () => win.matchMedia(`(min-width: ${breakpoints.medium})`);
export function getDeviceSize() {
    if (isServer()) {
        return 'LARGE';
    }
    // Run the checks in size order to cache the biggest device that
    // matches the query.
    if (mediaQueryHuge().matches) {
        return 'HUGE';
    }
    else if (mediaQueryExtraLarge().matches) {
        return 'EXTRALARGE';
    }
    else if (mediaQueryLarge().matches) {
        return 'LARGE';
    }
    else if (mediaQueryMedium().matches) {
        return 'MEDIUM';
    }
    else {
        return 'SMALL';
    }
}
//# sourceMappingURL=device.js.map